export enum FileParentEnum {
  CONTRACT = 1,
  INSTALLMENTREQUIREMENT = 2,
  PAYMENT = 3,
  CLAIM = 4,
  INVENTORY = 5,
  CASHFLOW= 6
}
